import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { AcuityEmbed } from "@/components/site/AcuityEmbed";
import { AcuityConversionListener } from "@/components/site/AcuityConversionListener";

export const Route = createFileRoute("/schedule-a-consult/")({
  head: () => ({
    meta: [
      // Indexable since 1 Oct 2026 (approved by Anthony): Ahrefs reported
      // "Noindex page receives organic traffic" for this page. The booking
      // pages for single clinics are indexable too (since 3 Oct 2026).
      { title: "Schedule a Free Hair Transplant Consultation | RESTORE Hair" },
      {
        name: "description",
        content:
          "Book your complimentary RESTORE Hair consultation. Choose a time that works for you and meet with a hair restoration specialist.",
      },
      { property: "og:title", content: "Schedule a Free Hair Transplant Consultation | RESTORE Hair" },
      {
        property: "og:description",
        content:
          "Book your complimentary RESTORE Hair consultation online.",
      },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/schedule-a-consult/" }],
  }),
  component: ScheduleAConsultPage,
});

function ScheduleAConsultPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="mx-auto max-w-5xl px-4 py-10 md:py-14">
        <h1 className="text-center text-3xl font-normal text-foreground md:text-5xl">
          Schedule Your <strong className="font-extrabold">FREE</strong> Hair Consultation
        </h1>
        <p className="mt-4 text-center text-base text-muted-foreground md:text-lg">
          Select a time for a free hair transplant consultation
        </p>
        <AcuityConversionListener />
        <div className="mt-8">
          <AcuityEmbed
            src="https://app.squarespacescheduling.com/schedule.php?owner=24213130"
            initialHeight={1600}
          />
        </div>
        <ClinicBookingLinks />
      </main>
      <Footer />
    </div>
  );
}
// Every clinic booking page. Before this list, /contact-us/ was the only page
// that linked to most of them (Ahrefs, 3 Oct 2026). Booking pages that answer
// 301 (brooklyn, highland-park-place, south-lake) are not listed.
const CLINIC_BOOKING_PAGES = [
  { label: "Boulder, CO", href: "/schedule-a-consult/boulder/" },
  { label: "Charlotte, NC", href: "/schedule-a-consult/charlotte/" },
  { label: "Denver, CO", href: "/schedule-a-consult/denver/" },
  { label: "Greenwood Village, CO", href: "/schedule-a-consult/greenwood-village/" },
  { label: "Chicago Fulton Market, IL", href: "/schedule-a-consult/fulton-market/" },
  { label: "Chicago Lincoln Park, IL", href: "/schedule-a-consult/lincoln-park/" },
  { label: "Lake Forest, IL", href: "/schedule-a-consult/lake-forest/" },
  { label: "Oak Brook, IL", href: "/schedule-a-consult/oak-brook/" },
  { label: "Schaumburg, IL", href: "/schedule-a-consult/schaumburg/" },
  { label: "Manhattan, NY", href: "/schedule-a-consult/manhattan/" },
  { label: "Plano, TX", href: "/schedule-a-consult/plano/" },
  { label: "Virtual consultation", href: "/schedule-a-consult/virtual/" },
];

function ClinicBookingLinks() {
  return (
    <section className="mt-12 text-center">
      <h2 className="text-xl font-bold text-foreground">Book at a Clinic</h2>
      <nav aria-label="Clinic booking pages" className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm">
        {CLINIC_BOOKING_PAGES.map((c) => (
          <a key={c.href} href={c.href} className="text-primary underline underline-offset-4 hover:no-underline">
            {c.label}
          </a>
        ))}
      </nav>
    </section>
  );
}
